/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type utilizationBarChartComponentRefetchQueryVariables = {
    shareKey?: string | null | undefined;
    dateCriteria?: string | null | undefined;
    componentId?: string | null | undefined;
    personIds?: Array<string | null> | null | undefined;
    teamIds?: Array<string | null> | null | undefined;
    roleIds?: Array<string | null> | null | undefined;
    labelIds?: Array<string | null> | null | undefined;
};
export type utilizationBarChartComponentRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"utilizationBarChartComponent_viewer">;
    } | null;
};
export type utilizationBarChartComponentRefetchQuery = {
    readonly response: utilizationBarChartComponentRefetchQueryResponse;
    readonly variables: utilizationBarChartComponentRefetchQueryVariables;
};



/*
query utilizationBarChartComponentRefetchQuery(
  $shareKey: String
  $dateCriteria: String
  $componentId: ID
  $personIds: [ID]
  $teamIds: [ID]
  $roleIds: [ID]
  $labelIds: [ID]
) {
  viewer {
    ...utilizationBarChartComponent_viewer_2dlyKa
    id
  }
}

fragment utilizationBarChartComponent_viewer_2dlyKa on Viewer {
  insightComponentsData(shareKey: $shareKey) {
    utilizationBarChart(dateCriteria: $dateCriteria, personIds: $personIds, componentId: $componentId, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds) {
      data {
        id
        personName
        availableHours
        projectHours
        idleHours
        registeredHours
        plannedCardHours
        timeOffHours
      }
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shareKey",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateCriteria",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "componentId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roleIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labelIds",
    "type": "[ID]"
  }
],
v1 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v2 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v3 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v4 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v5 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v6 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v7 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "utilizationBarChartComponentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "utilizationBarChartComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "utilizationBarChartComponentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v6/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "concreteType": "UtilizationBarChart",
                "kind": "LinkedField",
                "name": "utilizationBarChart",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UtilizationBarChartElement",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "idleHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "registeredHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "plannedCardHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeOffHours",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "utilizationBarChartComponentRefetchQuery",
    "operationKind": "query",
    "text": "query utilizationBarChartComponentRefetchQuery(\n  $shareKey: String\n  $dateCriteria: String\n  $componentId: ID\n  $personIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n) {\n  viewer {\n    ...utilizationBarChartComponent_viewer_2dlyKa\n    id\n  }\n}\n\nfragment utilizationBarChartComponent_viewer_2dlyKa on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    utilizationBarChart(dateCriteria: $dateCriteria, personIds: $personIds, componentId: $componentId, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds) {\n      data {\n        id\n        personName\n        availableHours\n        projectHours\n        idleHours\n        registeredHours\n        plannedCardHours\n        timeOffHours\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '037cca0ebbd1732cb3ed7adbb7fbf591';
export default node;
